import * as yup from 'yup'
import { THIS_FIELD_IS_REQUIRED_MESSAGE } from '../constants/validations'

export const PersonAdditionalDataSchema = yup.object().shape({
  usReportablePerson: yup.string().required(THIS_FIELD_IS_REQUIRED_MESSAGE),
  politicallyExposedPerson: yup.string().required(THIS_FIELD_IS_REQUIRED_MESSAGE),
})
